import React from "react"
import SwitchFilter from "../Fields/SwitchFilter"

const GeoDMA = () => {
  return (
    <SwitchFilter next={"State"} prev={"Zip Code Radius"} custBuild={true} />
  )
}

export default GeoDMA
